import "./HeaderLine.scss";
import { Link } from "react-router-dom";
import { languageElements } from "./HeaderLine-languageElements";
import LanguageElementsHandler from "../../repository/languageElementsHandler/LanguageElementsHandler";
import PictHandler from "./pictures/PictHandler";
import { List as MenuIcon } from "react-bootstrap-icons";
import useMain from "../../common/MainContext";

export default function HeaderLine(props) {
  const { loginData, language } = useMain();

  const languageElementsHandler = new LanguageElementsHandler(
    languageElements,
    language
  );
  const selectedPage = props.selectedPage;
  let navbar;
  let navItems;

  switch (loginData?.tokenData.user.userLevel) {
    case "CUSTOMER":
      navItems = [
        "home",
        "invoices",
        "stocks",
        "tracking",
        "settings",
        "contact",
      ];
      break;

    case "CUST_ROOT":
      navItems = [
        "home",
        "invoices",
        "stocks",
        "tracking",
        "settings",
        "contact",
      ];
      break;

    case "OWNER_ROOT":
      navItems = [
        "home",
        "invoices",
        "stocks",
        "tracking",
        "settings",
        "contact",
      ];
      break;

    case "SEL_ADMIN":
      navItems = [
        "home",
        "invoices",
        "stocks",
        "tracking",
        "settings",
        "contact",
      ];
      break;

    default:
      navItems = [
        "home",
        "contact",
      ];
  }

  if (loginData && navItems.length > 0) {
    let linkStyle = { width: `calc( 100% / ${navItems.length} - 4px )` };

    navbar = navItems.map((item) => {
      if (item === selectedPage) {
        return (
          <div key={item} style={linkStyle}>
            <Link to={`/${item}`} className="main-navbar-item btn btn-primary">
              <PictHandler pictureCode={`${item}_selected`} />
              <span>{languageElementsHandler.get(`header-title-${item}`)}</span>
            </Link>
          </div>
        );
      }

      return (
        <div key={item} style={linkStyle}>
          <Link to={`/${item}`} className="main-navbar-item btn btn-light">
            <PictHandler pictureCode={item} />
            <span>{languageElementsHandler.get(`header-title-${item}`)}</span>
          </Link>
        </div>
      );
    });
  }

  return (
    <div className="header-line">
      {
        loginData &&
        <div className="main-navbar">
          {navbar}
        </div>
      }

      <h1 className="header-title-bar">
        <div className="header-title-bar-column-1" onClick={props.onHamClicked}>
          {props.onHamClicked ? <MenuIcon width={28} height={28} /> : null}
        </div>
        <div className="header-title-bar-column-2">
          {languageElementsHandler.get(`header-title-${selectedPage}`)}
        </div>
        <div className="header-title-bar-column-3"></div>
      </h1>
    </div>
  );
}
